import type { LayerKey } from '@festina-life/api'
import { createRequiredContext } from '@festina-life/ui/libs'

import type { DraftInitialValues } from './types'

type TemplateDraftContextType = {
  onConfigureNewDraft: (input: DraftInitialValues, layer: LayerKey) => void
}

const [useDraftContext, Provider] =
  createRequiredContext<TemplateDraftContextType>('Draft')

export { Provider, useDraftContext }
